
import React, { useMemo } from 'react';

import {
  Container,
  Line,
  Graph,
  Yellow,
  Blue,
  Transparent,
  Legend,
  Min,
  Recomended,
} from './styles'
import { getModulesByExamType } from '../constants/examRecommendations';

type Props = {
  examType?: 'cfp' | 'cfa';
}

const StaticGraph = ({ examType = 'cfp' }: Props) => {
  const modules = getModulesByExamType(examType);
  const minPercent = 50; // Mínimo para aprovação

  const renderedModules = useMemo(() => {
    return modules.map((moduleData) => {
      const minCorrect = Math.round((moduleData.questions * minPercent) / 100);
      const recommendedCorrect = Math.round((moduleData.questions * moduleData.recommended) / 100);

      return (
        <React.Fragment key={moduleData.module}>
          <p><strong>Módulo {moduleData.module}:</strong> {moduleData.questions} questões</p>
          <Graph>
            <Yellow percent={minPercent}>
              <p>{minCorrect} acertos • {minPercent}%</p>
            </Yellow>
            <Blue percent={moduleData.recommended}>
              <p>{recommendedCorrect} acertos • {moduleData.recommended}%</p>
            </Blue>
            <Transparent percent={100}>
              <p>{moduleData.questions}</p>
            </Transparent>
          </Graph>
          <Line />
        </React.Fragment>
      );
    });
  }, [modules, minPercent]);

  return (
    <Container>
      {renderedModules}
      <Legend>
        <Min>
          <div />
          <p>Mínimo para aprovação {examType === 'cfa' ? 'no CFA' : 'na Planejar'}</p>
        </Min>
        <Recomended>
          <div />
          <p>Recomendação Academia Rafael Toro nos simulados</p>
        </Recomended>
      </Legend>
    </Container>
  );
};

export default StaticGraph;
